<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title="Penyata Pemungut Senarai Kaunter">

            <w-form >
              <w-flex class="mt3">
                <div class="xs4 mr3">
                       <w-input
                        label="No. Penyata Pemungut"
                        name="tarikh_tansaksi"
                        v-model="cari.no_penyata_pemungut">
                       </w-input>
                    </div>
                <div class="xs4 mr3">
                       <w-input
                        type="date"
                        label="Tarikh Transaksi"
                        name="tarikh_tansaksi"
                        v-model="cari.tarikh_transaksi">
                       </w-input>
                    </div>
                <div class="xs4 mr3">
                       <w-input
                        type="date"
                        label="Hingga"
                        name="hingga_tarikh"
                        v-model="cari.hingga_tarikh">
                       </w-input>
                    </div>
                    
              </w-flex>
              <w-flex class="mt3">
                <div class="xs4 mr3">
                     <z-lookup :url="service_kutipan +'lookup/jabatan_baharu'"
                    :sort="false"
                    :cache="false"
                    v-model="cari.jabatan_id"
                    label="jabatan"
                />
                </div>
                <div class="xs4 mr3">
                        <template v-if="cari.proses == 1 && cari.lkp_cara_bayaran_id > 0">
                        <z-lookup
                        label="Kaedah Bayaran"
                        :url='service_utiliti+"lookup/cara_bayar_kaunter"'
                        :sort="false" :cache="false"
                        v-model="cari.lkp_cara_bayaran_id"/>
                        </template>
                        <template v-else>
                        <z-lookup
                        label="Kaedah Bayaran"
                        placeholder="Sila Pilih Kaedah Bayaran"
                        :url='service_utiliti+"lookup/cara_bayar_kaunter"'
                        :sort="false" :cache="false"
                        v-model="cari.lkp_cara_bayaran_id"/>
                        </template>
                </div>
                <div class="xs4">
                        <z-lookup label="Status" name="status" :url='service_utiliti+"lookup/pemungut_status"' :sort="false" :cache="false" v-model="cari.lkp_penyata_pemungut_status_id" /> 
                    </div>
                
            </w-flex>
            </w-form>

            <div class="mt2 text-right">
                <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                    <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                </w-button>
                <w-button class="ml1 " @click="search()" :loading="cari.loading">
                    <w-icon>fal fa-search</w-icon>&nbsp;Cari
                </w-button>
            </div>
            <br>

            <center v-if="loading"><w-progress class="ma1" circle></w-progress></center>
            <center v-if="cari.loading"><w-progress class="ma1" circle></w-progress></center>           
            
            <z-table ref="tbluser" title="Senarai : Penyata Pemungut" :headers="table.headers" :items="table.items" :meta="table.meta" class="">
                <template #item-cell.amaun="{ item, label, header, index }">
                    {{$zutil.currency(item.amaun)}}
                </template>
                <template #item-cell.action="{ item, label, header, index }">
                  <w-flex class="flex justify-center">
                    <inertia-link :href='$route("kutipan.pemungut.show",item.id)'>
                        <w-tooltip top>
                           <template #activator="{ on }">
                             <w-icon v-on="on" >
                               fal fa-file
                             </w-icon>
                           </template>
                           Papar
                         </w-tooltip>
                        </inertia-link>
                  </w-flex>
                </template>
            </z-table>

        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
  },
  data() {
    return {
        resourceurl: this.service_kutipan +'penyata_pemungut',
        reload: true,
        loading: true,
        cari : {
            loading: false,
        },
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
            { label: 'iHasil', route: '/ihasil' },
            { label: 'Kutipan', route: '/kutipan' },
            { label: 'Penyata Pemungut', route: 'kutipan.penyata_pemungut.index' }
          ],
           cari : {lkp_cara_bayaran_id:'', tarikh_transaksi: '' , hingga_tarikh:'', no_penyata_pemungut: '', lkp_penyata_pemungut_status_id : '', jabatan_id : '', proses : 0},
        }
         
  },
  methods: {
        search() {
            this.cari.loading = true
            var url = window.route('kutipan.pemungut.index')+'?lkp_cara_bayaran_id='+this.cari.lkp_cara_bayaran_id+'&tarikh_transaksi='+this.cari.tarikh_transaksi+'&hingga_tarikh='+this.cari.hingga_tarikh+'&no_penyata_pemungut='+this.cari.no_penyata_pemungut+'&lkp_penyata_pemungut_status_id='+this.cari.lkp_penyata_pemungut_status_id+'&jabatan_id='+this.cari.jabatan_id+'&proses=1';
            this.$inertia.visit(url, { preserveScroll : true})
          },
          reset(){
            this.cari = {lkp_cara_bayaran_id: '', tarikh_transaksi: '', hingga_tarikh: '', no_penyata_pemungut : '', lkp_penyata_pemungut_status_id : '', proses : 0}
            var url = window.route('kutipan.pemungut.index')+'?lkp_cara_bayaran_id='+this.cari.lkp_cara_bayaran_id+'&tarikh_transaksi='+this.cari.tarikh_transaksi+'&hingga_tarikh='+this.cari.hingga_tarikh+'&no_penyata_pemungut='+this.cari.no_penyata_pemungut+'&lkp_penyata_pemungut_status_id='+this.cari.lkp_penyata_pemungut_status_id+'&jabatan_id='+this.cari.jabatan_id+'&proses=0';
            this.$inertia.visit(url, { preserveScroll : true})
          },
        
  },
  watch: {
    
  },
  mounted() {
    // override default setting
    this.dialog.width = 900
    this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.cari && this.cari.no_penyata_pemungut && this.cari.no_penyata_pemungut == 'undefined'){
      this.cari.no_penyata_pemungut = ''
    }
     if(this.cari && this.cari.lkp_penyata_pemungut_status_id && this.cari.lkp_penyata_pemungut_status_id == 'undefined'){
      this.cari.lkp_penyata_pemungut_status_id = ''
    }
      
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>